import React from 'react';
import { Drawer, List, ListItem, ListItemText, Hidden, Collapse, ListItemButton, Typography, Box, Divider } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import AssessmentIcon from '@mui/icons-material/Assessment';
import SettingsIcon from '@mui/icons-material/Settings';
import { NavLink, useParams } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import { Link, useLocation } from 'react-router-dom';
import { faHouse, faBusinessTime, faDroplet, faBoltLightning, faFire, faChargingStation, faGaugeSimple, faClipboard, faHeadset, faUser } from '@fortawesome/pro-solid-svg-icons';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import BKABLogo from 'src/components/BKABLogo';

const useStyles = makeStyles(() => ({
  mobileDrawer: {
    width: 300
  },
  desktopDrawer: {
    width: 300,
    top: 64,
    height: 'calc(100% - 64px)'
  },
  avatar: {
    cursor: 'pointer',
    width: 64,
    height: 64
  },
  links: {
    color: "#546E7A",
    textDecoration: "none",
    fontWeight: 500,
    padding: 12,
    borderRadius: 8,
    display: 'flex',
    alignItems: 'center', // Vertically centers the icon and text
    cursor: "pointer"
  },
  activeLink: {
    color: "#1976D2 !important", 
  },
  icon: {
    width: '10%', // Fixed width for icons
    marginRight: '8px', // Consistent spacing between icon and text
    display: 'flex',
    justifyContent: 'center', // Centers the icon horizontally in its space
  },
  list: {
    padding: 8
  },
  nested: {
    paddingLeft: 48,
    color: "#546E7A",
    textDecoration: "none",
    fontWeight: 500,
    borderRadius: 8,
    display: 'flex',
    alignItems: 'center',
  },
  chevron: {
    marginLeft: 'auto',
  }
}));

function NavbarItem({ icon, text, link, onNavItemClick, children, iconColor }){
    const classes = useStyles();
    const location = useLocation();
    const [open, setOpen] = useState(false);

    //const isActive = location.pathname === link;

    console.log(location.pathname);
    console.log(link);

    const isActive =
    location.pathname === link.split('?')[0] ||
    React.Children.toArray(children).some(child => {
      return React.isValidElement(child) && (location.pathname + location.search) === child.props.link;
    });

    
    const handleClick = (e) => {
      if (children) {
        e.preventDefault();
        setOpen(!open);
      }
      if (onNavItemClick) onNavItemClick();
    };

    return(
      <>
        <ListItemButton 
          component={children ? 'div' : Link} 
          to={children ? undefined : link} 
          onClick={handleClick}
          className={`${classes.links} ${isActive ? classes.activeLink : ''}`}
        >
          <div className={classes.icon}>
            <FontAwesomeIcon icon={icon} size="1x" color={iconColor} />
          </div>
          <span>{text}</span>
          {children && (
            <FontAwesomeIcon 
              icon={open ? faChevronUp : faChevronDown} 
              className={classes.chevron}
            />
          )}
        </ListItemButton>
        {children && (
          <Collapse in={open} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {children}
            </List>
          </Collapse>
        )}
      </>
    );
}

function NestedNavbarItem({ text, icon, link, onNavItemClick, iconColor }) {
  const classes = useStyles();
  const location = useLocation();
  const isActive = link.includes('?') 
    ? location.pathname + location.search === link
    : location.pathname === link && !location.search;

  return (
    <ListItemButton
      component={Link} 
      to={link}
      onClick={onNavItemClick}
      className={`${classes.nested} ${isActive ? classes.activeLink : ''}`}
      sx={{paddingLeft: "38px !important"}}
    >
      <div className={classes.icon}>
        <FontAwesomeIcon icon={icon} size="1x" color={iconColor} />
      </div>
      <span>{text}</span>
    </ListItemButton>
  );
}

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function NavbarItems({ onNavItemClick, consumption }) {
  const classes = useStyles();
  const { denotation, encFlat, encCustomer } = useParams();
  const isEncrypted = !!encFlat && !!encCustomer;
  const query = useQuery();
  const { user } = useSelector(state => state.account);

  /*const getLinkBase = (path) => {
    if (isEncrypted) {
      return `/customerview/${path}/${encFlat}/${encCustomer}?${query}`;
    }
    return `/customerview/${path}/${denotation}?${query}`;
  };*/

  const getLinkBase = (path) => {
    if (isEncrypted) {
      return path
        ? `/customerview/${path}/${encFlat}/${encCustomer}?${query}`
        : `/customerview/${encFlat}/${encCustomer}?${query}`;
    }
    return path
      ? `/customerview/${path}/${denotation}?${query}`
      : `/customerview/${denotation}?${query}`;
  };

  return (
    <>
      <NavbarItem 
        icon={faHouse} 
        text="Summering" 
        link={getLinkBase("")} 
        onNavItemClick={onNavItemClick}
      />

      {consumption?.coldWaterSensorsExists && (
        <NavbarItem 
          icon={faDroplet} 
          text="Kallvatten" 
          link={getLinkBase("coldwater")} 
          onNavItemClick={onNavItemClick} 
        />
      )}

      {consumption?.hotWaterSensorsExists && (
        <NavbarItem 
          icon={faDroplet} 
          iconColor="red" 
          text="Varmvatten" 
          link={getLinkBase("hotwater")} 
          onNavItemClick={onNavItemClick} 
        />
      )}

      {consumption?.electicitySensorsExists && (
        <NavbarItem 
          icon={faBoltLightning} 
          text="Elektricitet" 
          link={getLinkBase("electricity")} 
          onNavItemClick={onNavItemClick} 
        />
      )}

      {consumption?.heatEnergySensorsExists && (
        <NavbarItem 
          icon={faFire} 
          text="Värmeenergi" 
          link={getLinkBase("heatenergy")} 
          onNavItemClick={onNavItemClick} 
        />
      )}

      {consumption?.evChargingSensorsExists && (
        <NavbarItem 
          icon={faChargingStation} 
          text="Elbilsladdning" 
          link={getLinkBase("evcharging")} 
          onNavItemClick={onNavItemClick} 
        />
      )}

      <NavbarItem 
        icon={faClipboard} 
        text="Energibesparingstips" 
        link={getLinkBase("advices")} 
        onNavItemClick={onNavItemClick} 
      />

      {(consumption?.supportAddress !== "" || 
        consumption?.supportEmail !== "" || 
        consumption?.supportPhone !== "" || 
        consumption?.supportWebsite !== "") && (
        <NavbarItem 
          icon={faHeadset} 
          text="Supportinformation" 
          link={getLinkBase("support")} 
          onNavItemClick={onNavItemClick} 
        />
      )}

      {user?.usertype === 3 &&
       <NavbarItem 
        icon={faUser} 
        text="Lösenord" 
        link={`/customerview/changepassword/${denotation}?${query}`} 
        onNavItemClick={onNavItemClick} 
      />
      }
    </>
  );

  /*return (
    <>
      <NavbarItem icon={faHouse} text="Summering" link={`/customerview/${denotation}?${query}`} onNavItemClick={onNavItemClick}/>

      {consumption?.coldWaterSensorsExists && (
        <NavbarItem icon={faDroplet} iconColor="" text="Kallvatten" link={`/customerview/coldwater/${denotation}?${query}`} onNavItemClick={onNavItemClick}/>
      )}

      {consumption?.hotWaterSensorsExists && (
        <NavbarItem icon={faDroplet} iconColor="red" text="Varmvatten" link={`/customerview/hotwater/${denotation}?${query}`} onNavItemClick={onNavItemClick}/>
      )}

      {consumption?.electicitySensorsExists && (
        <NavbarItem icon={faBoltLightning} text="Elektricitet" link={`/customerview/electricity/${denotation}?${query}`} onNavItemClick={onNavItemClick}/>
      )}

      {consumption?.heatEnergySensorsExists && (
        <NavbarItem icon={faFire} text="Värmeenergi" link={`/customerview/heatenergy/${denotation}?${query}`} onNavItemClick={onNavItemClick}/>
      )}

      {consumption?.evChargingSensorsExists && (
        <NavbarItem icon={faChargingStation} text="Elbilsladdning" link={`/customerview/evcharging/${denotation}?${query}`} onNavItemClick={onNavItemClick}/>
      )}

      <NavbarItem icon={faClipboard} text="Energibesparingstips" link={`/customerview/advices/${denotation}?${query}`} onNavItemClick={onNavItemClick}/>

      {(consumption?.supportAddress !== "" || consumption?.supportEmail !== "" || consumption?.supportPhone !== "" || consumption?.supportWebsite !== "") && (
        <NavbarItem icon={faHeadset} text="Supportinformation" link={`/customerview/support/${denotation}?${query}`} onNavItemClick={onNavItemClick}/>
      )}

      {/*consumption?.averageMetering !== null && (
        <NavbarItem icon={faGaugeSimple} text="Snittvärden" link={`/customerview/average/${denotation}?${query}`} onNavItemClick={onNavItemClick}/>
      )}
    </>
  );*/
}

const NavBar = ({ openMobile, onMobileClose, consumption }) => {
    const classes = useStyles();
    return (
    <>
    <Hidden lgUp>
      <Drawer
      anchor="left"
      classes={{ paper: classes.mobileDrawer }}
      onClose={onMobileClose}
      open={openMobile}
      variant="temporary"
      >
        <Box display="flex" flexDirection="column" height="100%">
          <Box flexGrow={1} overflow="auto">
          <List className={classes.list}>
            <NavbarItems onNavItemClick={onMobileClose} consumption={consumption}/>
          </List>
          </Box>
          <Box padding={2} align="center">
            <BKABLogo />
          </Box>
        </Box>
      </Drawer>
    </Hidden>
    <Hidden lgDown>
      <Drawer
      anchor="left"
      classes={{ paper: classes.desktopDrawer }}
      open
      variant="persistent"
      >
        <Box display="flex" flexDirection="column" height="100%">
          <Box flexGrow={1} overflow="auto">
          <List className={classes.list}>
            <NavbarItems consumption={consumption}/>
          </List>
          </Box>
          <Box padding={2} align="center">
            <BKABLogo />
          </Box>
        </Box>
      </Drawer>
    </Hidden>
    </>
    );
};

export default NavBar;